export default {
  name: 'transaction_customer_business_name',
  component_path: 'modules/procedures/blocks/BlockInputText',
  static_options: {
    autocomplete: 'organization'
  }
}